import React from "react";

import ContentGutter from "../ContentGutter";
import SiteWrapper from "../SiteWrapper";
import { AsHtml } from "utils/translate";
import check from "../../styles/imgs/check.svg";

import styles from "./styles.module.scss";

export default function Checklist({ items, icon = "" }) {
  const renderItems = () => {
    return items.map((item, i) => (
      <div className={styles.wrapper} key={i}>
        <img
          className={styles.check}
          alt="check icon"
          src={icon ? icon : check}
        />
        <p className={styles.item}>
          <AsHtml value={item} />
        </p>
      </div>
    ));
  };

  return (
    <div className={styles.content}>
      <ContentGutter>
        <SiteWrapper size="small">
          <div className={styles.checklist}>{renderItems()}</div>
        </SiteWrapper>
      </ContentGutter>
    </div>
  );
}
